// test32
(32 && 0);
